module.exports = "/_next/static/videos/CATS-d0fe06a7f9c13de00df999b99da9f1c8.mp4";